export function getDocumentDimensions(
  element?: HTMLElement | null | undefined
) {
  let ownerDocument = document!;
  let ownerWindow = document.defaultView || window;
  if (!ownerDocument) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: ownerDocument.documentElement.clientWidth ?? ownerWindow.innerWidth,
    height:
      ownerDocument.documentElement.clientHeight ?? ownerWindow.innerHeight
  };
}
